import { render } from "./DropdownClose.vue?vue&type=template&id=05ed2ac6&scoped=true"
import script from "./DropdownClose.vue?vue&type=script&lang=js"
export * from "./DropdownClose.vue?vue&type=script&lang=js"

import "./DropdownClose.vue?vue&type=style&index=0&id=05ed2ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ed2ac6"]])

export default __exports__